"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var model = workspace.getModel();
    var sparqlDataProvider = new index_1.SparqlDataProvider({
        endpointUrl: '/sparql',
        queryMethod: index_1.SparqlQueryMethod.GET
    }, index_1.OWLStatsSettings);
    var graphBuilder = new index_1.SparqlGraphBuilder(sparqlDataProvider);
    var loadingGraph = graphBuilder.getGraphFromConstruct("CONSTRUCT {\n            ?inst rdf:type ?class.\n            ?inst ?propType1 ?propValue1.\n            ?inst rdfs:label ?label .\n            ?propValue2 ?propType2 ?inst .\n        } WHERE {\n            BIND (<http://collection.britishmuseum.org/id/object/JCF8939> as ?inst)\n            ?inst rdf:type ?class.\n            OPTIONAL {?inst rdfs:label ?label}\n            OPTIONAL {?inst ?propType1 ?propValue1.  FILTER(isURI(?propValue1)). }\n            OPTIONAL {?propValue2 ?propType2 ?inst.  FILTER(isURI(?propValue2)). }\n        } LIMIT 100");
    workspace.showWaitIndicatorWhile(loadingGraph);
    loadingGraph.then(function (_a) {
        var diagram = _a.diagram, preloadedElements = _a.preloadedElements;
        return model.importLayout({
            diagram: diagram,
            preloadedElements: preloadedElements,
            dataProvider: sparqlDataProvider,
        });
    }).then(function () {
        workspace.forceLayout();
        workspace.zoomToFit();
    });
}
var props = {
    ref: onWorkspaceMounted,
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
